import { render } from "./UiSelect.vue?vue&type=template&id=4d41cf9e&scoped=true"
import script from "./UiSelect.vue?vue&type=script&lang=js"
export * from "./UiSelect.vue?vue&type=script&lang=js"

import "./UiSelect.vue?vue&type=style&index=0&id=4d41cf9e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d41cf9e"]])

export default __exports__